import { BaseModel } from '../../../Common/Basic/models/base.model';
import { SsoProviderApiModel } from '../../../api/accounts/models/sso-provider.api.model';


export enum SsoProviderIdEnum {
    google = 1,
    microsoft = 2
}


export class SsoProvider extends BaseModel<SsoProvider, SsoProviderApiModel> {

    id: number;
    name: string;

    constructor(apiModel?: SsoProviderApiModel) {
        super();
        if (apiModel) {
            this.constructFromApiModel(apiModel);
        } else {
            this.constructDefault();
        }
    }

    constructFromApiModel(apiModel: SsoProviderApiModel) {
        this.id = apiModel.id;
        this.name = apiModel.name;
    }

    constructDefault() {
        this.id = null;
        this.name = '';
    }


    toApiModel(): SsoProviderApiModel {
        return {
            id: this.id,
            name: this.name,
        };
    }

    clone(): SsoProvider {
        const clone = new SsoProvider();

        clone.id = this.id;
        clone.name = this.name;

        return clone;
    }

    equals(other: SsoProvider): boolean {
        if (this.id !== other.id) {
            return false;
        }

        if (this.name !== other.name) {
            return false;
        }

        return true;
    }
}
